export const sp = 900
export const pcStyle = `@media (min-width: ${sp + 1}px)`
export const spStyle = `@media (max-width: ${sp}px)`
